// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1LuvV","errors":"Errors_errors__2UiK1"};